import { format } from "date-fns";
import { api } from "@/api";
import type {
  IChubbBillInsuranceOrdersRequest,
  IChubbBillInsuranceOrdersResponse,
  IChubbBillInsurancesResponse,
} from "./types";

export const getChubbBillInsurances = async () =>
  (
    await api.get<IChubbBillInsurancesResponse>(
      "/insurances/chubb-bill-insurances",
    )
  ).data;

export const getChubbBillInsuranceOrders = async () =>
  (
    await api.get<IChubbBillInsuranceOrdersResponse>(
      "/insurances/chubb-bill-insurances/orders",
    )
  ).data;

export const submitChubbBillInsuranceOrders = async (
  data: IChubbBillInsuranceOrdersRequest,
) =>
  await api.post(
    "/insurances/chubb-bill-insurances/orders",
    {
      dateOfBirth: format(data.dateOfBirth, "yyyy-MM-dd"),
      acceptedBillInsuranceTerms: data.acceptedBillInsuranceTerms,
      acceptedDataTransferToBillInsurer: data.acceptedDataTransferToBillInsurer,
    },
    {
      headers: {
        jointBillServiceId: data.jointBillServiceId,
      },
      timeout: 60000,
    },
  );

export const deactivateChubbInsurance = async (jointBillServiceId: number) =>
  await api.put<void>(
    `/insurances/chubb-bill-insurances/orders/cancellations`,
    undefined,
    {
      headers: { jointBillServiceId },
      timeout: 60000,
    },
  );
